import {
    CREATE_CHALLENGE_FAILED,
    CREATE_CHALLENGE_REQUESTED,
    CREATE_CHALLENGE_SUCCEEDED,
    CLEAR_CREATED_CHALLENGE,
    FEATURED_CHALLENGE_REQUESTED,
    FEATURED_CHALLENGE_SUCCEEDED,
} from './constants';

const initialState = {
    createdChallenge: null,
    featuredChallenges: [],
    createChallengeError: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CREATE_CHALLENGE_REQUESTED: {
            return {
                ...state,
                creatingChallenge: true,
                createChallengeError: null,
            };
        }
        case CREATE_CHALLENGE_SUCCEEDED: {
            const { challenge } = action;
            return {
                ...state,
                creatingChallenge: false,
                createdChallenge: challenge,
            };
        }
        case CREATE_CHALLENGE_FAILED: {
            const { error } = action;
            return {
                ...state,
                creatingChallenge: false,
                createChallengeError: error,
            };
        }
        case CLEAR_CREATED_CHALLENGE: {
            return {
                ...state,
                createdChallenge: null,
            };
        }
        case FEATURED_CHALLENGE_REQUESTED: {
            return {
                ...state,
            };
        }
        case FEATURED_CHALLENGE_SUCCEEDED: {
            const { featuredChallenges } = action;
            return {
                ...state,
                featuredChallenges,
            };
        }
        default:
            return state;
    }
}
